import ServiceCard, { ServiceCardProps } from './ServiceCard';

export type { ServiceCardProps };
export default ServiceCard;
